export default function compose(...fns) {
  return (arg) => fns.reduceRight((acc, v) => v(acc), arg);
}
